import { useEffect, useState } from "react";
import { api, fmtCurrency, fmtDate } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Search } from "lucide-react";
import { Badge } from "../../components/ui/badge";

export default function AdminUsers() {
    const [users, setUsers] = useState([]);
    const [q, setQ] = useState("");

    useEffect(() => { api.get("/admin/users").then((r) => setUsers(r.data)); }, []);

    const filtered = users.filter((u) => {
        if (!q) return true;
        const s = q.toLowerCase();
        return (u.full_name || "").toLowerCase().includes(s) ||
               (u.email || "").toLowerCase().includes(s) ||
               (u.phone || "").includes(s);
    });

    return (
        <div data-testid="admin-users-page">
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h1 className="font-display text-2xl font-semibold text-[#0A1930]">Users</h1>
                    <p className="text-sm text-slate-500 mt-1">{users.length} registered users</p>
                </div>
                <div className="relative w-72">
                    <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                    <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by name, email, phone…" className="pl-9 h-10 rounded-xl" data-testid="users-search" />
                </div>
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden product-shadow">
                <div className="overflow-x-auto admin-scroll">
                    <table className="w-full text-sm">
                        <thead className="bg-slate-50">
                            <tr className="text-left text-xs uppercase tracking-wider font-bold text-slate-500">
                                <th className="px-5 py-3">User</th>
                                <th className="px-5 py-3">Email</th>
                                <th className="px-5 py-3">Phone</th>
                                <th className="px-5 py-3">Role</th>
                                <th className="px-5 py-3">KYC</th>
                                <th className="px-5 py-3">Score</th>
                                <th className="px-5 py-3">Joined</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((u) => (
                                <tr key={u.id} className="border-b border-slate-100" data-testid={`user-row-${u.id}`}>
                                    <td className="px-5 py-3 flex items-center gap-3">
                                        {u.avatar_url ? (
                                            <img src={u.avatar_url} alt="" className="size-8 rounded-full object-cover" />
                                        ) : (
                                            <div className="size-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 text-xs font-bold">
                                                {(u.full_name || "?").slice(0, 1)}
                                            </div>
                                        )}
                                        <span className="font-medium">{u.full_name}</span>
                                    </td>
                                    <td className="px-5 py-3 text-slate-600 font-mono text-xs">{u.email}</td>
                                    <td className="px-5 py-3 text-slate-600 font-mono text-xs">{u.phone}</td>
                                    <td className="px-5 py-3"><Badge variant="outline" className="capitalize">{u.role}</Badge></td>
                                    <td className="px-5 py-3">
                                        <Badge className={u.kyc_status === "verified" ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-700 border-amber-200"}>
                                            {u.kyc_status}
                                        </Badge>
                                    </td>
                                    <td className="px-5 py-3 font-bold">{u.credit_score}</td>
                                    <td className="px-5 py-3 text-slate-500 text-xs">{fmtDate(u.created_at)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
